import React, { useState, useEffect } from "react";
import { Form, ButtonItem, GroupItem, SimpleItem } from "devextreme-react/form";
import EndpointsApi from "../../api/admin/endpointsApi";
import { Snackbar } from "../../components";

const snackbarType = {
	success: "success",
	error: "error",
};

export default function ComCourtApiSettings() {
	const [endpoints, setEndpoints] = useState([]);
	const [loading, setLoading] = useState(true);
	const [saving, setSaving] = useState(false);
	const [testing, setTesting] = useState(false);

	const [snackbarOptions, setSnackbarOptions] = useState({
		visible: false,
		type: "",
		message: "",
	});

	const showNotification = (message, type) => {
		setSnackbarOptions({
			message,
			type,
			visible: true,
		});
	};

	const onCloseSnackbar = () => {
		setSnackbarOptions({
			...snackbarOptions,
			visible: false,
		});
	};

	useEffect(() => {
		fetchEndpoints();
	}, []);

	const fetchEndpoints = async () => {
		try {
			const endpointsData = await EndpointsApi.getAllEndpointsAsync();
			setEndpoints(endpointsData);
		} catch (error) {
			console.error("Error fetching endpoints:", error);
		} finally {
			setLoading(false);
		}
	};

	const formData = endpoints.reduce((acc, endpoint) => {
		acc[endpoint.key] = endpoint.path;
		return acc;
	}, {});

	const handleFieldChange = (e) => {
		const updatedEndpoints = endpoints.map((endpoint) => {
			if (endpoint.key === e.dataField) {
				return { ...endpoint, path: e.value };
			}
			return endpoint;
		});
		setEndpoints(updatedEndpoints);
	};

	const handleSubmit = async (e) => {
		setSaving(true);

		try {
			const resultData = await EndpointsApi.updateEndpointsAsync(
				endpoints
			);
			//console.log("Settings were successfully updated.", snackbarType.success)

			if (resultData.isSuccess === true) {
				showNotification(
					"Settings were successfully updated.",
					snackbarType.success
				);
			} else {
				showNotification(
					"Error saving settings: " + resultData.message,
					snackbarType.error
				);
			}
		} catch (error) {
			console.error(error);
			showNotification("Error saving settings:", snackbarType.error);
		} finally {
			setSaving(false);
		}
	};

	const handleTest = async (e) => {
		setTesting(true);

		try {
			const testResult = await EndpointsApi.testEndpointsAsync();
			setTesting(false);

			if (testResult.isSuccess) {
				showNotification(testResult.result, snackbarType.success);
			} else {
				showNotification(testResult.message, snackbarType.error);
			}
		} catch (error) {
			console.error(error);
			showNotification("Testing error", snackbarType.error);
			setTesting(false);
		}
	};

	const submitButtonOptions = {
		text: saving ? "Saving..." : "Save",
		useSubmitBehavior: true,
		stylingMode: "outlined",
		width: "100px",
		disabled: saving,
		horizontalAlignment: "right",
	};

	const testButtonOptions = {
		text: testing ? "Testing..." : "Test",
		useSubmitBehavior: false,
		stylingMode: "outlined",
		width: "100px",
		disabled: testing,
		horizontalAlignment: "left",
	};

	if (loading) {
		return <div>Loading...</div>;
	}

	return (
		<React.Fragment>
			<h2 className={"content-block"}>
				Commissioners Court API Settings
			</h2>

			<div className={"content-block dx-card responsive-paddings"}>
				<Form
					id={"form"}
					formData={formData}
					onFieldDataChanged={handleFieldChange}
					labelLocation={"top"}
					onSubmit={handleSubmit}
				>
					<GroupItem colCountByScreen={colCountByScreen}>
						{endpoints.map((endpoint) => (
							<SimpleItem
								key={endpoint.id}
								dataField={endpoint.key}
								label={{ text: endpoint.description }}
							/>
						))}
					</GroupItem>
					<GroupItem colCountByScreen={colCountByScreen}>
						<ButtonItem
							buttonOptions={{
								...testButtonOptions,
								onClick: handleTest,
							}}
						/>
						<ButtonItem
							buttonOptions={{
								...submitButtonOptions,
								onClick: handleSubmit,
							}}
						/>
					</GroupItem>
				</Form>
				<Snackbar
					message={snackbarOptions.message}
					onHiding={onCloseSnackbar}
					of={".content"}
					options={snackbarOptions}
				/>
			</div>
		</React.Fragment>
	);
}

const colCountByScreen = {
	xs: 1,
	sm: 1,
	md: 2,
	lg: 2,
};
